<template>
  <div class="pagination">
    <div class="pagination__text">
      {{ page }}/{{ pageCount }}
    </div>

    <b-button :disabled="page == 1" @click="onPage(page - 1)">
      Назад
    </b-button>

    <b-button :disabled="pageCount == page" @click="onPage(page + 1)">
      Далі
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  
  props: ['pageCount', 'page'],

  methods: {
    onPage (page) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page
        }
      })

      this.$emit('update')
    }
  }
}
</script>

<style lang="scss">
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 24px 0;

    & > * {
      margin-left: 8px;
    }
  }
</style>
